import { createAction } from '../../../utils/redux/createAction';
import {
  HEIGHT_METRIC,
  TEMPERATURE_METRIC,
  WEIGHT_METRIC,
  GLUCOSE_METRIC,
} from '../../../constants';
import {
  CHART_FILTERS_TYPE,
  VITALS_ACTIVITY_TYPE,
} from '../../../components/PatientHealthboard/constants';

const actionsScope = 'profile/current-healthboard-options';

export const CURRENT_HEALTHBOARD_OPTIONS = {
  SET_DATA_TYPE: `${actionsScope}/setDataType`,
  SET_CHART_PERIOD: `${actionsScope}/setChartPeriod`,
  SET_CURRENT_METRIC_WEIGHT: `${actionsScope}/setCurrentMetricWeight`,
  SET_CURRENT_METRIC_HEIGHT: `${actionsScope}/setCurrentMetricHeight`,
  SET_CURRENT_METRIC_TEMPERATURE: `${actionsScope}/setCurrentMetricTemperature`,
  SET_CURRENT_METRIC_GLUCOSE: `${actionsScope}/setCurrentMetricGlucose`,
  SET_CURRENT_METRIC: `${actionsScope}/setCurrentMetric`,
  CLEAR: `${actionsScope}/clear`,
};

export const currentHealthboardOptionsActions = {
  setDataType: createAction(CURRENT_HEALTHBOARD_OPTIONS.SET_DATA_TYPE),
  setChartPeriod: createAction(CURRENT_HEALTHBOARD_OPTIONS.SET_CHART_PERIOD),
  setCurrentMetricWeight: createAction(
    CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_WEIGHT,
  ),
  setCurrentMetricHeight: createAction(
    CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_HEIGHT,
  ),
  setCurrentMetricTemperature: createAction(
    CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_HEIGHT,
  ),
  setCurrentMetricGlucose: createAction(
    CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_GLUCOSE,
  ),
  setCurrentMetric: createAction(
    CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC,
  ),
  clear: createAction(CURRENT_HEALTHBOARD_OPTIONS.CLEAR),
};

const initialState = {
  dataType: VITALS_ACTIVITY_TYPE.STEPS,
  chartPeriod: CHART_FILTERS_TYPE.DAY.type,
  previousCounter: 1,
  currentMetricWeight: { type: WEIGHT_METRIC.POUNDS, valueToAPI: null },
  currentMetricHeight: { type: HEIGHT_METRIC.FEET_INCHES, valueToAPI: null },
  currentMetricGlucose: {
    type: GLUCOSE_METRIC.MMOL_PER_LITER,
    valueToAPI: null,
  },
  currentMetricTemperature: {
    type: TEMPERATURE_METRIC.FAHRENHEIT,
    valueToAPI: null,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CURRENT_HEALTHBOARD_OPTIONS.SET_DATA_TYPE: {
      return {
        ...state,
        dataType: payload,
      };
    }

    case CURRENT_HEALTHBOARD_OPTIONS.SET_CHART_PERIOD: {
      return {
        ...state,
        chartPeriod: payload,
      };
    }

    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_WEIGHT: {
      return {
        ...state,
        currentMetricWeight: {
          ...state.currentMetricWeight,
          ...(payload.type && { type: payload.type }),
          valueToAPI:
            payload.valueToAPI || state.currentMetricWeight.valueToAPI,
        },
      };
    }

    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_HEIGHT: {
      return {
        ...state,
        currentMetricHeight: {
          ...state.currentMetricHeight,
          ...(payload.type && { type: payload.type }),
          valueToAPI:
            payload.valueToAPI || state.currentMetricHeight.valueToAPI,
        },
      };
    }

    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_GLUCOSE: {
      return {
        ...state,
        currentMetricGlucose: {
          ...state.currentMetricGlucose,
          ...(payload.type && { type: payload.type }),
          valueToAPI:
            payload.valueToAPI || state.currentMetricGlucose.valueToAPI,
        },
      };
    }

    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC: {
      return {
        ...state,
        [payload.type]: {
          type: payload.value,
        },
      };
    }

    case CURRENT_HEALTHBOARD_OPTIONS.CLEAR: {
      return {
        ...initialState,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/currentHealthboardOptions.js